const Spinner = () => {
    return (
        <div className="spinnerWrapper">
            <div className="three-body">
                <div className="three-body__dot"></div>
                <div className="three-body__dot"></div>
                <div className="three-body__dot"></div>
            </div>
        </div>
    );
};

export default Spinner;
